import Container from './ForumPage.container';
import Component from './ForumPage';

export default Container(Component);
